var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1612_2854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.99998C14.6666 11.682 11.6819 14.6666 7.99992 14.6666C4.31792 14.6666 1.33325 11.682 1.33325 7.99998C1.33325 4.31798 4.31792 1.33331 7.99992 1.33331M12.6666 1.33331V3.33331M12.6666 3.33331V5.33331M12.6666 3.33331H14.6666M12.6666 3.33331H10.6666",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65193 4.32533C4.94907 4.11598 5.30312 4.00246 5.6666 4C5.93993 4 6.33526 4.07667 6.68126 4.32533C7.06126 4.59867 7.33326 5.04933 7.33326 5.66667C7.33326 6.284 7.06126 6.734 6.68126 7.00733C6.3842 7.21692 6.03015 7.33068 5.6666 7.33333C5.39326 7.33333 4.99793 7.25667 4.65193 7.00733C4.27193 6.734 3.99993 6.28467 3.99993 5.66667C3.99993 5.04933 4.27193 4.59933 4.65193 4.32533ZM10.8873 14.6293C12.4073 14.118 15.3333 12.0953 15.3333 8C15.3333 7.82319 15.263 7.65362 15.138 7.5286C15.013 7.40357 14.8434 7.33333 14.6666 7.33333H13.9999C10.7979 7.33333 8.5266 8.048 6.96326 9.08133C8.31993 9.52267 9.6806 10.2947 10.7166 11.582C10.8275 11.7199 10.879 11.8962 10.8599 12.0721C10.8407 12.248 10.7525 12.4091 10.6146 12.52C10.4767 12.6309 10.3004 12.6824 10.1245 12.6633C9.94856 12.6441 9.78746 12.5559 9.6766 12.418C8.6666 11.162 7.24326 10.4767 5.8126 10.1447C5.04047 9.96831 4.25059 9.88151 3.4586 9.886C2.93593 9.888 2.47393 9.93 2.10926 9.99067C2.05819 9.9993 2.00629 10.002 1.9546 9.99867L1.8906 10.0093C1.79178 10.0258 1.69794 10.0644 1.61608 10.1222C1.53421 10.1799 1.46642 10.2554 1.41774 10.343C1.36905 10.4305 1.34073 10.5279 1.33488 10.6279C1.32903 10.728 1.34579 10.828 1.38393 10.9207C1.8186 11.9767 2.80726 13.4027 4.3906 14.3187C6.00393 15.2513 8.17993 15.624 10.8873 14.6293Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1612_2854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicker);
export default __webpack_public_path__ + "static/media/picker.7ae3621271a394cf1efc86685a2186e0.svg";
export { ForwardRef as ReactComponent };